import React, {PropTypes} from 'react';
const s = require('./breadcrumbs.scss');

const Breadcrumbs = ({title, showing}) => {
  return (
    <div>
      <p className={s.pageBreadcrumb}>{showing} <strong data-hook="title">{title}</strong></p>
    </div>
  );
};

Breadcrumbs.propTypes = {
  title: PropTypes.string.isRequired,
  showing: PropTypes.string.isRequired
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./components/partial/Breadcrumbs/Breadcrumbs.js